import { storageData } from "@/assets/js/storage";

export default {
  data() {
    return {
      fileUpHeaders: {
        "X-Token": storageData.getToken(),
        "X-UserType": storageData.getUserType(),
      },
      fileUpParam: {},
      uploadAction: '/api/enroll/upload_enroll_file.json'
    }
  },

  methods: {
    // 配置默认上传组件的方法（可覆盖，建议使用方式）
    /**
     * 
     * @param {Object} file 
     * @param {Array} fileList 
     * @param {Number} max 
     * :on-exceed="(files, fileList) => handleExceed(files, fileList, limitNum)"
     */
    handleUploadExceedCommon(file, fileList, max) {
      this.$message.warning(`该项最多允许上传文件数量${max}`)
    },

    /**
     * 
     * @param {*} listName 
     * @param {*} listType 
     * @param {*} file 
     * @returns Boolean
     * 注意，这里上传文件用方法（后台参数 document: file）
     */
    handleUploadFileBeforeCommon(listType, file) {
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error("文件大小不能超过50M!");
        return false;
      }
      if (!/^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
          this.$message.error("请上传jpg jpeg png pdf xlsx xls docx doc格式的文件!");
          return false;
      }
      let param = {
        document: file,
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },

    handleUploadImgBeforeCommon(file) {
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error("文件大小不能超过50M!");
        return false;
      }
      if(listType === 'access') {
        if (!/^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
          this.$message.error("请上传jpg jpeg png pdf xlsx xls docx doc格式的文件!");
          return false;
        }
      } else {
        // if (!/^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
        if (!/^.*\.(jpg|jpeg|png)$/i.test(file.name)) {
          this.$message.error("请上传 jpg jpeg png格式的文件!");
          return false;
        }  
      }
      let param = {
        document: file, // document\ excel\ word\ img\
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },
  },
}